(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secret-complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-look-group]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const panels = Array.from(group.querySelectorAll('[data-look-panel]'));
      const next = group.closest('.sl-wrap').querySelector('[data-next-look]');
      let current = 0;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'he', { style: 'currency', currency: group.dataset.currency || 'ILS' });
      if (panels.length > 1) next.hidden = false;
      next.addEventListener('click', () => {
        panels[current].hidden = true;
        current = (current + 1) % panels.length;
        panels[current].hidden = false;
      });
      panels.forEach(form => {
        const selects = Array.from(form.querySelectorAll('[data-look-variant]'));
        const button = form.querySelector('.sl-add');
        form.addEventListener('change', event => {
          const select = event.target.closest('[data-look-variant]');
          if (!select) return;
          const option = select.selectedOptions[0];
          const item = select.closest('.sl-item');
          item.querySelector('[data-item-price]').textContent = option.dataset.money;
          if (option.dataset.image) {
            const image = item.querySelector('img');
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
          const total = selects.reduce((sum, entry) => sum + Number(entry.selectedOptions[0].dataset.price || entry.dataset.basePrice), 0);
          form.querySelector('[data-look-total]').textContent = money.format(total / 100);
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (button.disabled || !form.reportValidity()) return;
          button.disabled = true;
          next.disabled = true;
          const status = form.querySelector('[data-look-status]');
          status.textContent = group.dataset.busy;
          try {
            const response = await fetch(group.dataset.add + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:selects.map(select => ({id:select.value,quantity:1}))})});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || group.dataset.error);
            window.location.assign(group.dataset.cart);
          } catch (error) {
            status.textContent = group.dataset.error;
            form.querySelector('[data-cart-check]').hidden = false;
          }
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secret-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.sfooter-chat');
  if (link && window.$respond && typeof window.$respond.do === 'function') {
    event.preventDefault();
    window.$respond.do('chat:open');
  }
});
(() => {
  let attempts = 0;
  const cleanChatLabel = () => {
    const root = document.getElementById('tidio-chat')?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById('secret-chat-clean-label')) {
      const style = document.createElement('style');
      style.id = 'secret-chat-clean-label';
      style.textContent = '[data-testid="widgetLabel"] img.emoji { display: none !important; }';
      root.appendChild(style);
    }
    return true;
  };
  if (cleanChatLabel()) return;
  const timer = setInterval(() => {
    attempts += 1;
    if (cleanChatLabel() || attempts >= 120) clearInterval(timer);
  }, 500);
})();

  } catch(e) { console.error(e); }
})();
})();
